// Mock data for Eduvantage Enrolled Agent Course clone (Archio design)

export const heroImages = {
  left: '/images/site/01-pexels-photo-8297076.jpg',
  right: '/images/site/02-photo-1554224155-6726b3ff858f.jpg',
};

export const clientAvatars = [
  '/images/site/03-wxk1fgerqctl3mvynsnvizhzhd0.png',
  '/images/site/04-v1dhlozlj9d8mrutl9vlh2w5na4.png',
  '/images/site/05-ft5evnhjnz7msjwhj5yocenu10.png',
  '/images/site/06-py29f6nxibd07rhod2bbuavnyku.png',
];

export const services = [
  {
    id: 1,
    slug: 'ea-course',
    icon: 'GraduationCap',
    title: 'Enrolled Agent Course',
    description:
      'Complete 3-part SEE exam preparation with live training. Master individual, business tax, and IRS representation in 6 months.',
    images: [
      '/images/site/01-pexels-photo-8297076.jpg',
      '/images/site/07-pexels-photo-7821544.jpg',
    ],
  },
  {
    id: 2,
    slug: 'us-taxation',
    icon: 'Calculator',
    title: 'US Taxation Training',
    description:
      'Hands-on training in US tax filing for individuals and businesses using QuickBooks and Zoho Books with real-world tax returns.',
    images: [
      '/images/site/02-photo-1554224155-6726b3ff858f.jpg',
      '/images/site/08-photo-1554224154-26032ffc0d07.jpg',
    ],
  },
  {
    id: 3,
    slug: 'business-setup',
    icon: 'Building2',
    title: 'US Business Setup',
    description:
      'Launch your own US tax firm from India with just $100. Guidance on LLC/C-Corp formation, EIN, and IRS registrations.',
    images: [
      '/images/site/09-pexels-photo-7821551.jpg',
      '/images/site/10-pexels-photo-37795357.jpg',
    ],
  },
  {
    id: 4,
    slug: 'placement',
    icon: 'Briefcase',
    title: 'Big 14 Placement Support',
    description:
      'Guaranteed placement assistance with Big 14 firms & top MNCs. Interview scheduling, resume building, and on-campus drives.',
    images: [
      '/images/site/11-pexels-photo-6981004.jpg',
      '/images/site/12-photo-1573496359142-b8d87734a5a2.jpg',
    ],
  },
];

export const marqueeTags = [
  'IRS Approved',
  'EA Certification',
  'Big 14 Placement',
  'US Taxation',
  'Live Training',
  'SEE Exam Prep',
  'Individual Tax',
  'Business Tax',
  'PTIN Registration',
  'Career Growth',
];

export const whyUsCards = [
  {
    icon: 'Award',
    title: 'IRS Authorized',
    description:
      'Federally recognized program aligned with IRS Special Enrollment Exam (SEE) syllabus and standards.',
  },
  {
    icon: 'Users',
    title: 'Expert Faculty',
    description:
      'Learn from Sijo Jacob, Founder of ProStrings, and industry veterans with decades of US tax experience.',
  },
  {
    icon: 'Briefcase',
    title: 'Job Guaranteed',
    description:
      'Placement assistance within 6 months post-certification with Big 14 firms and MNCs.',
  },
];

export const trustBadges = [
  { icon: 'BadgeCheck', label: '200+ Students Enrolled' },
  { icon: 'Award', label: 'IRS Recognized' },
  { icon: 'ShieldCheck', label: 'Big 14 Placements' },
  { icon: 'TrendingUp', label: '4.9/5 Rated Course' },
];

export const processSteps = [
  {
    number: '1',
    title: 'Enroll & Get PTIN',
    description:
      'Sign up for the course and obtain your Preparer Tax Identification Number (PTIN) to be eligible for the SEE exams.',
  },
  {
    number: '2',
    title: 'Master 3 Parts',
    description:
      'Study Part 1 (Individuals), Part 2 (Businesses), and Part 3 (Representation) with 200+ simulation questions and live classes.',
  },
  {
    number: '3',
    title: 'Get Certified & Placed',
    description:
      'Pass all three SEE exams, complete 200 hours of live training, and get placed with Big 14 firms and top MNCs.',
  },
];

export const comparisonRows = [
  { benefit: 'Structured 6-month curriculum.', internet: false, expert: true },
  { benefit: '200+ SEE simulation questions.', internet: false, expert: true },
  { benefit: 'Live training on QuickBooks & Zoho.', internet: false, expert: true },
  { benefit: 'IRS SEE Part 1, 2, 3 mock exams.', internet: false, expert: true },
  { benefit: '200 hours real-world tax filing practice.', internet: false, expert: true },
  { benefit: 'Guaranteed Big 14 placement support.', internet: false, expert: true },
];

export const testimonials = [
  {
    id: 1,
    name: 'Vikaram',
    role: 'EA Certified Professional',
    image: '/images/site/13-ozhemhvlo3ymqguxsstqsaxr5g4.jpg',
    quote:
      'Eduvantage are pioneers in US taxation training. They take keen details on accounting, taxation and assurance. One of the most well-known companies with real expertise in the field.',
    location: 'Bengaluru, IN',
    type: 'EA Course',
    rating: 5,
  },
  {
    id: 2,
    name: 'Dhanveer Raja',
    role: 'Tax Consultant',
    image: '/images/site/14-mmfd1jnhrlphupph6f2oudonrc.png',
    quote:
      'I’ve taken the EA course here and the training quality is exceptional. The team is confident about placement in top auditing firms, and the way they teach makes complex US tax concepts genuinely easy.',
    location: 'Chennai, IN',
    type: 'EA Course',
    rating: 5,
  },
  {
    id: 3,
    name: 'Rajesh M',
    role: 'Junior Tax Analyst',
    image: '/images/site/15-ilfncjkxnpgobcry4pwnmckuxom.png',
    quote:
      'The class sessions are well-structured and engaging. The teaching style is clear and easy to understand, ensuring concepts are well explained. Access to recorded class files makes revision effortless.',
    location: 'Hyderabad, IN',
    type: 'US Taxation',
    rating: 5,
  },
  {
    id: 4,
    name: 'Priya Sharma',
    role: 'CA turned EA',
    image: '/images/site/16-nzbzkwdi8svcyw8fvz6sxqf66f8.png',
    quote:
      'As a Chartered Accountant looking to expand into US taxation, this course was the perfect bridge. Passed all 3 SEE parts in 5 months and started my own consultancy serving US clients.',
    location: 'Mumbai, IN',
    type: 'Business Setup',
    rating: 5,
  },
  {
    id: 5,
    name: 'Arun Krishnan',
    role: 'Senior Tax Associate',
    image: '/images/site/17-nkgbdkt3maown7iw0zfxvme9oa.jpg',
    quote:
      'Placed in a Big 14 firm within 3 months of certification. The 200 hours of live training on real tax returns made all the difference. My interview confidence came from actual hands-on practice.',
    location: 'Kochi, IN',
    type: 'Placement',
    rating: 5,
  },
];

export const stats = [
  { value: '200+', label: 'Students trained.' },
  { value: '4.9/5', label: 'Average course rating.' },
  { value: '6 mo', label: 'To certification.' },
];

export const blogPosts = [
  {
    id: 1,
    slug: 'why-become-enrolled-agent',
    title: 'Why Become an Enrolled Agent in 2026?',
    excerpt:
      'EAs earn ₹45K–₹70K/month starting salary and can practice independently. Discover why EA is the fastest route to a global tax career from India.',
    image: '/images/site/07-pexels-photo-7821544.jpg',
    date: 'Jan 12, 2026',
    tag: 'Career',
    readTime: '9 min read',
    sections: [
      {
        id: 'introduction',
        heading: 'Introduction',
        body: [
          'The Enrolled Agent (EA) credential is the highest tax certification issued by the U.S. Internal Revenue Service (IRS). Unlike CA, CMA, or CS — which take 3–5 years — an EA can be earned in as little as 6 months, and unlocks the fastest route into US taxation, Big 14 firms, and even independent practice.',
          'This guide breaks down what an EA is, why 2026 is the best year to pursue it, and how it compares to other finance certifications available to Indian graduates.',
        ],
      },
      {
        id: 'what-is-ea',
        heading: 'What is an Enrolled Agent?',
        body: [
          'An Enrolled Agent (EA) is a tax professional federally authorized by the IRS to represent U.S. taxpayers before all administrative levels of the IRS — audits, appeals, and collections. EAs share the same unlimited practice rights as CPAs and attorneys when it comes to IRS matters.',
          'The credential is granted after passing the three-part Special Enrollment Examination (SEE) and completing a background check. There is no degree requirement — anyone above 18 with a PTIN can attempt the exams.',
        ],
      },
      {
        id: 'benefits',
        heading: 'Why EA is trending in 2026',
        body: [
          '**Fastest global credential:** Complete in 6 months vs 4–5 years for CA.',
          '**No prerequisites:** 10+2 and age 18+ is enough — you do not need commerce background.',
          '**Global demand:** Big 14 firms (Deloitte, EY, PwC, KPMG + 10 more) are recruiting hundreds of EAs from India annually.',
          '**High salary early:** Freshers start at ₹5–8 LPA, and 3-year experienced EAs regularly earn ₹15+ LPA.',
          '**Independent practice:** Once licensed you can serve US clients remotely from India — many EAs run six-figure practices from home.',
        ],
      },
      {
        id: 'salary',
        heading: 'What EAs earn in India',
        body: [
          'Entry-level EA salaries range from ₹5–8 LPA in Big 14 firms and captive MNCs. Senior tax associates with 3–5 years of experience take home ₹12–18 LPA. Independent practitioners servicing US clients earn ₹40K to ₹1L per return during tax season.',
          'For a detailed breakdown of firm-wise salaries, see our [Big 14 Placement Guide](/blog/big14-placement-guide).',
        ],
      },
      {
        id: 'compared',
        heading: 'EA vs CPA vs CA — should I switch?',
        body: [
          'If you already hold a CA or CMA, the EA course is a natural extension — most concepts overlap with US taxation, and you can add international scope in just 6 months. Read our full [EA vs CPA vs CA comparison](/blog/ea-vs-cpa-vs-ca) for a side-by-side breakdown.',
        ],
      },
      {
        id: 'next-steps',
        heading: 'How to start today',
        body: [
          '1. Register for the [SEE exam](/blog/see-exam-strategy) via Prometric.',
          '2. Get your [PTIN](/blog/ptin-registration-guide) — takes 15 minutes online.',
          '3. Enroll in a structured EA program that includes live tax return practice.',
          'Book a free trial class through the left action panel to see how Eduvantage runs its 6-month EA program.',
        ],
      },
    ],
    related: ['see-exam-strategy', 'ea-vs-cpa-vs-ca', 'big14-placement-guide'],
    tags: ['EA', 'Career', 'Tax', 'IRS'],
  },
  {
    id: 2,
    slug: 'see-exam-strategy',
    title: 'How to Crack All 3 SEE Exams in 6 Months',
    excerpt:
      'A month-by-month study plan for Part 1 (Individuals), Part 2 (Businesses), and Part 3 (Representation) with practice tips from top scorers.',
    image: '/images/site/08-photo-1554224154-26032ffc0d07.jpg',
    date: 'Feb 08, 2026',
    tag: 'Study Guide',
    readTime: '12 min read',
    sections: [
      {
        id: 'overview',
        heading: 'SEE exam overview',
        body: [
          'The IRS Special Enrollment Examination (SEE) is the gateway to the Enrolled Agent credential. It consists of three separate exams, each covering a distinct area of US taxation, with 100 multiple-choice questions per part in a 4-hour window.',
          'You can attempt the parts in any order. Once you pass one part, the other two must be cleared within a rolling 3-year window (previously 2 — updated in the 2024 IRS revision).',
        ],
      },
      {
        id: 'part-1',
        heading: 'Part 1 — Individual Taxation',
        body: [
          'This is the most beginner-friendly of the three parts and where most candidates start. Topics include preliminary taxpayer data, income, deductions, credits, and specialized returns.',
          '**Recommended study time:** 6–8 weeks. Focus on Form 1040, Schedule A, B, C, D, and E.',
          'See our [Why Become an EA](/blog/why-become-enrolled-agent) for context on which forms carry the most weightage.',
        ],
      },
      {
        id: 'part-2',
        heading: 'Part 2 — Business Taxation',
        body: [
          'Considered the hardest of the three because of the breadth: partnerships (Form 1065), C-corps (Form 1120), S-corps (Form 1120-S), estates, trusts, and tax-exempt entities.',
          '**Recommended study time:** 8–10 weeks. Practice at least 500 questions across all sub-topics before attempting.',
        ],
      },
      {
        id: 'part-3',
        heading: 'Part 3 — Representation, Practices & Procedures',
        body: [
          'Part 3 covers IRS practices, ethics, representation, and filing procedures. It is the shortest to prepare for and most candidates score highest here.',
          '**Recommended study time:** 3–4 weeks. Memorize Circular 230 and Practice Guidelines.',
        ],
      },
      {
        id: 'study-plan',
        heading: 'A month-by-month 6-month plan',
        body: [
          '**Month 1–2:** Part 1 fundamentals + 500 practice MCQs.',
          '**Month 3:** Attempt Part 1 exam. Score confidence: 105/130.',
          '**Month 3–4:** Part 2 fundamentals — corporations & partnerships.',
          '**Month 5:** Attempt Part 2. Simultaneously start Part 3.',
          '**Month 6:** Attempt Part 3, complete license application.',
        ],
      },
      {
        id: 'top-tips',
        heading: 'Tips from top scorers',
        body: [
          '1. Never memorize forms — understand the *flow* of income → adjustments → deductions → credits.',
          '2. Use 200+ IRS simulation questions per part. Eduvantage bundles these into the [course package](/ea-course).',
          '3. Book weekly mock tests in the Prometric-style interface at least 4 weeks before your real attempt.',
          '4. Read the [PTIN registration guide](/blog/ptin-registration-guide) *before* scheduling your first paper.',
        ],
      },
    ],
    related: ['why-become-enrolled-agent', 'ptin-registration-guide', 'big14-placement-guide'],
    tags: ['SEE', 'Study Plan', 'Exam Prep'],
  },
  {
    id: 3,
    slug: 'start-us-tax-firm-india',
    title: 'EA02 Business Setup Program: What It Includes',
    excerpt:
      'A practical overview of the 24-month EA02 pathway, including EA training, business formation, accounting systems, cybersecurity, and onboarding.',
    image: '/images/site/09-pexels-photo-7821551.jpg',
    date: 'Mar 04, 2026',
    tag: 'Business',
    readTime: '10 min read',
    sections: [
      {
        id: 'why',
        heading: 'Why choose the EA02 pathway?',
        body: [
          'EA02 combines Enrolled Agent training with the practical systems required for a US tax business setup from India: formation, accounting workflow, cybersecurity, communication, and maintenance.',
          'Learn why the EA credential unlocks this in our [Why Become an EA](/blog/why-become-enrolled-agent) guide.',
        ],
      },
      {
        id: 'entity',
        heading: 'Business formation',
        body: [
          'The program covers US business formation, EIN support, liability insurance, Indian business formation, GST, LUT under GST, and inward remittance procedure.',
        ],
      },
      {
        id: 'ein-ptin',
        heading: 'EA and IRS setup',
        body: [
          'EIN (Employer Identification Number) is issued by the IRS to your business — apply via Form SS-4 (takes 4–8 weeks by fax from India).',
          'PTIN (Preparer Tax Identification Number) is issued to you personally, and is required to sign returns as a paid preparer. Read the full [PTIN registration guide](/blog/ptin-registration-guide).',
        ],
      },
      {
        id: 'efin',
        heading: 'Step 3 — Apply for EFIN',
        body: [
          'The Electronic Filing Identification Number (EFIN) allows you to e-file returns to the IRS. Applications take 45–60 days and require a fingerprint card. Without EFIN you can prepare returns but not e-file them.',
        ],
      },
      {
        id: 'operations',
        heading: 'Business operations training',
        body: [
          'The business training includes sales tax, payroll tax, SOP training, CRM procedure, tax software procedure, mail procedure, accounting reports, and professional communication standards.',
        ],
      },
      {
        id: 'cybersecurity',
        heading: 'Cybersecurity and maintenance',
        body: [
          'Cybersecurity support includes email security, mobile security, router encryption, ransomware prevention, backup systems, static IP with VPN, firewall setup, and annual audit support.',
        ],
      },
    ],
    related: ['why-become-enrolled-agent', 'ptin-registration-guide', 'ea-vs-cpa-vs-ca'],
    tags: ['Business', 'Practice', 'EFIN'],
  },
  {
    id: 4,
    slug: 'ea-vs-cpa-vs-ca',
    title: 'EA vs CPA vs CA: Which Should You Pursue?',
    excerpt:
      'A side-by-side comparison of duration, cost, scope, and salaries. EA takes 6 months; CPA 18 months; CA 4–5 years. Pick what fits your goals.',
    image: '/images/site/11-pexels-photo-6981004.jpg',
    date: 'Mar 22, 2026',
    tag: 'Comparison',
    readTime: '11 min read',
    sections: [
      {
        id: 'quick-answer',
        heading: 'The quick answer',
        body: [
          'If you want **speed + global reach + tax specialization**, choose EA. If you want **broadest US finance recognition**, choose CPA. If you want **India + Gulf recognition and a general accounting career**, choose CA.',
          'For a pure tax career serving US clients, EA is the shortest, cheapest, and highest-ROI path.',
        ],
      },
      {
        id: 'duration',
        heading: 'Duration & pass rates',
        body: [
          '**EA:** 6 months · Pass rate ~70% per part · 3 exams.',
          '**CPA (US):** 12–18 months · Pass rate ~50% per section · 4 exams.',
          '**CMA (US):** 6–9 months · Pass rate ~45% · 2 parts.',
          '**CA (India):** 4–5 years incl articleship · Pass rate ~10% at Final · 3 levels.',
          '**CS (India):** 3–4 years · Pass rate ~15% at Final · 3 levels.',
        ],
      },
      {
        id: 'cost',
        heading: 'Cost breakdown',
        body: [
          '**EA:** ₹75K–₹1.5L total (course + IRS fees).',
          '**CPA:** ₹3.5L–₹4.5L (evaluation, exam, review).',
          '**CMA:** ₹1.8L–₹2.5L.',
          '**CA:** ₹1L–₹3L across foundation, inter, final.',
          '**CS:** ₹40K–₹80K.',
        ],
      },
      {
        id: 'scope',
        heading: 'Scope after completion',
        body: [
          '**EA:** Represent taxpayers before IRS anywhere; hired by Big 14, and can practice solo. See our [Business Setup guide](/blog/start-us-tax-firm-india).',
          '**CPA:** Audit, assurance, tax, advisory — recognized as the global gold standard.',
          '**CMA:** Management accounting, FP&A, controllership roles.',
          '**CA:** Statutory audit, tax audit, GST practice, management consulting in India/Gulf.',
        ],
      },
      {
        id: 'switching',
        heading: 'Combining credentials',
        body: [
          'Many professionals stack certifications: CA + EA is a common combo enabling both Indian audit and US tax work. Similarly, CMA + EA gives you strong FP&A + tax representation capabilities.',
        ],
      },
      {
        id: 'verdict',
        heading: 'Our verdict',
        body: [
          'For a *first* professional credential, we recommend EA if your goal is a global career in 6 months. Read the [SEE exam strategy](/blog/see-exam-strategy) to see exactly how the roadmap looks.',
        ],
      },
    ],
    related: ['why-become-enrolled-agent', 'see-exam-strategy', 'start-us-tax-firm-india'],
    tags: ['Comparison', 'CPA', 'CA', 'CMA'],
  },
  {
    id: 5,
    slug: 'ptin-registration-guide',
    title: 'PTIN Registration — Step-by-Step Guide for Indian Candidates',
    excerpt:
      'PTIN is mandatory to sit for the SEE exam. Here is the exact 15-minute process for Indian applicants — links, forms, and payment method.',
    image: '/images/site/07-pexels-photo-7821544.jpg',
    date: 'Apr 10, 2026',
    tag: 'How-To',
    readTime: '7 min read',
    sections: [
      {
        id: 'what',
        heading: 'What is a PTIN?',
        body: [
          'A Preparer Tax Identification Number (PTIN) is a 9-digit ID issued by the IRS to every person who prepares or assists in preparing federal tax returns for compensation. Every EA must hold and renew a PTIN annually.',
          'You need the PTIN *before* scheduling any SEE exam through Prometric.',
        ],
      },
      {
        id: 'fee',
        heading: 'Fee and validity',
        body: [
          'PTIN fee is ~$19.75 per year (as of 2026). It is valid for one calendar year and must be renewed between Oct–Dec.',
        ],
      },
      {
        id: 'steps',
        heading: 'The 5-step process for Indian applicants',
        body: [
          '1. Visit irs.gov/tax-professionals/ptin-application-checklist and click "Create Account".',
          '2. Enter your personal info — passport number acts as your ID if you do not have an SSN.',
          '3. Complete Form W-12 answering "no" to the SSN question (choose reason "conscientious religious objection" only if applicable — most Indians select "foreign person").',
          '4. Pay the fee using any international debit/credit card.',
          '5. Receive PTIN via email within 24–48 hours.',
        ],
      },
      {
        id: 'after',
        heading: 'After you get your PTIN',
        body: [
          'Once your PTIN arrives, head to Prometric.com/see to schedule any of the [three exam parts](/blog/see-exam-strategy). We recommend starting with Part 1.',
        ],
      },
      {
        id: 'troubleshoot',
        heading: 'Common issues',
        body: [
          '**Payment failure:** Use a Visa/Mastercard issued in India — Amex sometimes fails. If your bank blocks the transaction, call and pre-authorize an international USD payment.',
          '**Address rejected:** Use the exact address on your passport; PIN codes are optional.',
          '**PTIN not received:** Check spam; escalate via the IRS PTIN helpline (+1 877-613-7846).',
        ],
      },
    ],
    related: ['see-exam-strategy', 'why-become-enrolled-agent', 'start-us-tax-firm-india'],
    tags: ['PTIN', 'IRS', 'How-To'],
  },
  {
    id: 6,
    slug: 'big14-placement-guide',
    title: 'Big 14 Placement Guide — Firms, Salaries & Interview Prep',
    excerpt:
      'Complete guide to Big 14 US tax firms hiring EAs from India — expected CTC, interview rounds, and how to stand out at campus drives.',
    image: '/images/site/12-photo-1573496359142-b8d87734a5a2.jpg',
    date: 'May 06, 2026',
    tag: 'Placement',
    readTime: '10 min read',
    sections: [
      {
        id: 'what-are-big14',
        heading: 'What is the Big 14?',
        body: [
          'The Big 4 (Deloitte, EY, PwC, KPMG) plus 10 other top US accounting firms — Grant Thornton, BDO, RSM, Baker Tilly, Crowe, CBIZ, Withum, EisnerAmper, Marcum, and Cherry Bekaert — form the "Big 14". All 14 actively hire Indian EAs for their US tax teams based out of Bengaluru, Hyderabad, Kochi, and Chennai.',
        ],
      },
      {
        id: 'salaries',
        heading: 'Expected salaries by firm',
        body: [
          '**Big 4:** ₹7–10 LPA fresher · ₹12–18 LPA at 3 years · ₹22–35 LPA at 5+ years.',
          '**BDO, RSM, Grant Thornton:** ₹6–9 LPA fresher · ₹10–15 LPA at 3 years.',
          '**Withum, EisnerAmper, Marcum:** ₹6–8 LPA fresher · ₹9–13 LPA at 3 years.',
          'See the [salary breakdown](/blog/why-become-enrolled-agent) for context on how EA compares to CA/CPA-only candidates.',
        ],
      },
      {
        id: 'rounds',
        heading: 'Interview rounds — what to expect',
        body: [
          '1. Aptitude test (30 mins) — logical + numerical + English.',
          '2. Technical round 1 — 15 case-based tax questions across Form 1040, 1120, and 1065.',
          '3. Technical round 2 — situational: how would you handle an IRS notice, a schedule K-1 error, etc.',
          '4. HR round — availability, relocation, US shift comfort.',
        ],
      },
      {
        id: 'prep',
        heading: 'How to prepare',
        body: [
          '1. Complete all three SEE parts before campus drives — most firms mandate this.',
          '2. Master QuickBooks, Zoho Books, and either UltraTax or Drake — spend 200+ hours on real returns during your course.',
          '3. Rehearse the "walk-me-through-a-1040" answer — this comes up in 90% of technical rounds.',
          '4. Follow the [study plan](/blog/see-exam-strategy) so you finish at least 500 mock questions.',
        ],
      },
      {
        id: 'network',
        heading: 'Networking beats applications',
        body: [
          '70% of Eduvantage graduates get placed via warm intros, not job portals. Join alumni WhatsApp groups (ask your placement counselor) and engage with Big 14 partners on LinkedIn — comment on their tax-season posts to be noticed.',
        ],
      },
    ],
    related: ['why-become-enrolled-agent', 'see-exam-strategy', 'ea-vs-cpa-vs-ca'],
    tags: ['Placement', 'Big 14', 'Salary', 'Interview'],
  },
];

export const faqs = [
  {
    question: 'What is the EA Course?',
    answer:
      'The EA (Enrolled Agent) Course is a Tax Filing Professional Certification, certified by the U.S. Tax Department (IRS). While CA, CMA, and CS take 4–6 years, the EA course can be completed with 3–6 months of focused study and practice.',
  },
  {
    question: 'Will I be able to crack the exams?',
    answer:
      'There are only three exams, each objective type. You can take all three separately, but if you clear one, the next must be attempted within 11 months. We provide 200+ question simulations per subject, so practising these will help you clear your exams comfortably.',
  },
  {
    question: 'Is it a diploma or a professional certification?',
    answer:
      'It is a Professional Certification with a license number to practice, issued by the U.S. Tax Department (IRS) — not a diploma.',
  },
  {
    question: 'How do I get a job after certification?',
    answer:
      'Once you clear the exams and complete live training, we assure placement within 6 months. This includes scheduling interviews with Big 14 companies and on-campus drives at our graduation ceremony.',
  },
  {
    question: 'Where do I get an internship?',
    answer:
      'We provide 200 hours of live training on individual tax return filing. After all three parts, you won’t need to search elsewhere — the practical training substitutes for an internship.',
  },
  {
    question: 'Who can apply for the course?',
    answer:
      'Anyone who has completed 10+2 (Higher Secondary) and is at least 18 years old can register for the SEE exams and this course.',
  },
  {
    question: 'What is the course duration and fee?',
    answer:
      'Duration is 6 months including live simulations for all three subjects. Fee starts at ₹75,000 with EMI options. Please contact us for the current pricing.',
  },
];

export const team = [
  {
    name: 'Sijo Jacob Joseph',
    role: 'Co-Founder · CEO, ProStrings',
    image: '/images/sijo-jacob.jpg',
    bio: 'Sijo brings 12+ years of US tax practice from top American firms directly into the Eduvantage classroom.',
  },
  {
    name: 'Koushik Rahul S',
    role: 'Founder · Eduvantage Solutions',
    image: '/images/koushik-rahul.jpg',
    bio: 'Koushik leads strategy, tax planning, bookkeeping, and fractional-CFO training for US-focused careers.',
  },
];

export const founder = {
  name: 'Sijo Jacob Joseph — Co-Founder of Eduvantage',
  quote:
    'Our mission is to make US taxation the fastest, most affordable path to a global career for Indian professionals.',
  image: '/images/sijo-jacob.jpg',
};

export const founders = [
  {
    name: 'Koushik Rahul S',
    role: 'Founder — Eduvantage Solutions',
    tagline: 'Tax Strategist · Fractional CFO',
    location: 'Bengaluru · Chennai',
    linkedin: 'https://www.linkedin.com/in/koushikrahuls',
    image: '/images/koushik-rahul.jpg',
    bio: 'Koushik founded Eduvantage Solutions in May 2022 to bridge the gap between Indian talent and the US Enrolled Agent pipeline. As Director & Co-Founder of ProStrings Inc, he leads tax planning, bookkeeping, and fractional-CFO engagements for US healthcare businesses.',
    highlights: [
      'Founder — Eduvantage Solutions (2022)',
      'Director & Co-Founder — ProStrings Inc',
      'Saved $6M+ for US healthcare businesses',
      'Speciality: Tax planning, payroll, fractional CFO',
    ],
  },
  {
    name: 'Sijo Jacob Joseph',
    role: 'Co-Founder — Eduvantage · CEO, ProStrings',
    tagline: 'Senior US Tax Specialist',
    location: 'Austin, Texas · US',
    linkedin: 'https://www.linkedin.com/in/sijo-jacob-joseph',
    image: '/images/sijo-jacob.jpg',
    bio: 'Sijo brings 12+ years of US tax practice from top American firms directly into the Eduvantage classroom. As CEO of ProStrings Inc, he oversees US bookkeeping, accounting, and advisory delivery from Austin, Texas.',
    highlights: [
      'CEO & Founder — ProStrings Inc',
      'Ex-Senior Tax Specialist, Warren Averett',
      'Ex-Tax Analyst, CohnReznick LLP',
      'Speciality: US bookkeeping, QuickBooks, Sage, Zoho',
    ],
  },
];

export const navLinks = [
  { name: 'Home', href: '/', anchor: '#home' },
  {
    name: 'Services',
    href: '/ea-course',
    mega: true,
    children: [
      {
        title: 'Courses',
        links: [
          { name: 'EA Course', href: '/ea-course', desc: 'IRS Enrolled Agent training and SEE exam preparation.' },
          { name: 'US Taxation', href: '/us-taxation', desc: 'Live software practice on US tax returns and forms.' },
        ],
      },
      {
        title: 'Business & Career',
        links: [
          { name: 'Business Setup', href: '/business-setup', desc: 'EA02 tax firm setup, SOP, accounting, and cybersecurity.' },
          { name: 'Placement Support', href: '/ea-course#placement', desc: 'Career readiness and Big 14 placement support.' },
        ],
      },
      {
        title: 'Resources',
        links: [
          { name: 'About', href: '/about', desc: 'Meet Eduvantage and the founding team.' },
          { name: 'FAQ', href: '/faq', desc: 'Quick answers about eligibility, exams, fees, and placements.' },
          { name: 'Blog', href: '/blog', desc: 'Guides on EA, PTIN, SEE exam strategy, and careers.' },
        ],
      },
      {
        title: 'Contact',
        links: [
          { name: 'Contact Us', href: '/contact', desc: 'Call, WhatsApp, or visit our offices.' },
        ],
        cta: true,
      },
    ],
  },
  { name: 'About', href: '/about' },
  { name: 'FAQ', href: '/faq' },
  { name: 'Blog', href: '/blog' },
  { name: 'Contact', href: '/contact' },
];

export const footerLinks = {
  services: [
    { name: 'EA Course', href: '/ea-course' },
    { name: 'US Taxation', href: '/us-taxation' },
    { name: 'Business Setup', href: '/business-setup' },
    { name: 'Placement Support', href: '/ea-course#placement' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Blog', href: '/blog' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Contact', href: '/contact' },
  ],
};

// EA Exam parts (used on EA course page)
export const examParts = [
  {
    part: 'Part 1',
    title: 'Individual Taxation',
    topics: [
      'Preliminary work with Taxpayer Data — 17 questions',
      'Income and Assets — 21 questions',
      'Deductions and Credits — 21 questions',
      'Taxation and Advice — 14 questions',
      'Specialized Returns for Individuals — 12 questions',
    ],
  },
  {
    part: 'Part 2',
    title: 'Business Taxation',
    topics: [
      'Business Entities — 28 questions',
      'Business Financial Information — 39 questions',
      'Specialized Returns and Taxpayers — 19 questions',
    ],
  },
  {
    part: 'Part 3',
    title: 'Representation & Practice',
    topics: [
      'Practices and Procedures — 25 questions',
      'Representation before the IRS — 24 questions',
      'Specific Types of Representation — 19 questions',
      'Filing Process — 17 questions',
    ],
  },
];

export const courseLearnings = [
  'Individual Tax Filing — Deductions, credits, and IRS compliance.',
  'Business Tax Filing — Partnerships, corporations, sole proprietorships.',
  'EA Practices — IRS representation, procedures, and ethics.',
  'Tax Software Training — Hands-on with QuickBooks and Zoho Books.',
  'Real-World Practice — 200 hours of live/dummy tax returns.',
  'Career Development — Resume, interviews, and professional etiquette.',
];

export const companyLogos = [
  '/images/site/22-c1.jpg',
  '/images/site/23-c2.jpg',
  '/images/site/24-c3.png',
  '/images/site/25-c4.png',
  '/images/site/26-c5.png',
  '/images/site/27-c7.png',
  '/images/site/28-c8.png',
  '/images/site/29-c9.png',
  '/images/site/30-c10.png',
  '/images/site/31-c11.png',
  '/images/site/32-c12.png',
  '/images/site/33-c13.png',
];

export const contactInfo = {
  email: 'info@eduvantage.co',
  phone: '+91 7010492161',
  hours: [
    { day: 'MON – FRI', time: '9:00am – 7:00pm' },
    { day: 'SAT', time: '9:00am – 5:00pm' },
    { day: 'SUN', time: '9:00am – 12:30pm' },
  ],
  address: 'Chennai: 5th Floor, Phase-2, Spencer Plaza Mall, 513-B, Anna Salai, Egmore, Chennai, Tamil Nadu 600002. Bengaluru: Tin Factory, 3rd Floor, Ranka Junction, AH45 Krishnarajapuram, Bengaluru, Karnataka 560016. Coimbatore: 147/G-9, Sri Sai Complex, Venkittapuram, Thadagam Road, Coimbatore 641025.',
  offices: [
    {
      city: 'Chennai',
      address: '5th Floor, Phase-2, Spencer Plaza Mall, 513-B, Anna Salai, Egmore, Chennai, Tamil Nadu 600002',
    },
    {
      city: 'Bengaluru',
      address: 'Tin Factory, 3rd Floor, Ranka Junction, AH45 Krishnarajapuram, Bengaluru, Karnataka 560016',
    },
    {
      city: 'Coimbatore',
      address: '147/G-9, Sri Sai Complex, Venkittapuram, Thadagam Road, Coimbatore 641025',
    },
  ],
  officeImage: '/images/site/10-pexels-photo-37795357.jpg',
};

// Brand logos bundled in the React public folder.
export const brandLogo = '/images/main-logo-trimmed.png';
export const brandLogoWhite = '/images/main-logo-white-trimmed.png';

// Live job openings for Tax Specialists (updated in real-time feel)
export const liveOpenings = [
  {
    id: 1,
    role: 'US Tax Specialist',
    company: 'BDO India',
    location: 'Bengaluru · Hybrid',
    salary: '₹8–14 LPA',
    experience: '1–3 yrs',
    posted: '2 hrs ago',
    tag: 'Big 14',
    seats: 4,
  },
  {
    id: 2,
    role: 'Senior Tax Associate (EA Preferred)',
    company: 'RSM US LLP',
    location: 'Hyderabad · On-site',
    salary: '₹12–18 LPA',
    experience: '2–5 yrs',
    posted: '5 hrs ago',
    tag: 'Urgent',
    seats: 2,
  },
  {
    id: 3,
    role: 'Enrolled Agent – Individual Returns',
    company: 'Grant Thornton',
    location: 'Kochi · Hybrid',
    salary: '₹9–15 LPA',
    experience: '1–4 yrs',
    posted: '1 day ago',
    tag: 'Big 14',
    seats: 6,
  },
  {
    id: 4,
    role: 'US Tax Analyst – 1040 & 1120',
    company: 'Withum India',
    location: 'Chennai · On-site',
    salary: '₹7–11 LPA',
    experience: '0–2 yrs',
    posted: '3 hrs ago',
    tag: 'Fresher OK',
    seats: 8,
  },
  {
    id: 5,
    role: 'Tax Consultant – IRS Representation',
    company: 'Eide Bailly',
    location: 'Remote · India',
    salary: '₹14–22 LPA',
    experience: '3–6 yrs',
    posted: '6 hrs ago',
    tag: 'Remote',
    seats: 1,
  },
  {
    id: 6,
    role: 'Junior US Tax Preparer',
    company: 'ProStrings Corporation',
    location: 'Kochi · On-site',
    salary: '₹4.5–7 LPA',
    experience: 'Fresher',
    posted: 'Just now',
    tag: 'Live',
    seats: 12,
  },
];

// Course Comparison — EA vs CPA vs CMA vs CA vs CS
export const courseComparison = {
  headers: ['Parameter', 'EA', 'CPA (US)', 'CMA (US)', 'CA (India)', 'CS (India)'],
  rows: [
    { label: 'Duration', values: ['6 months', '12–18 months', '6–9 months', '4–5 years', '3–4 years'] },
    { label: 'Total Exams', values: ['3 (SEE)', '4 (AUD/BEC/FAR/REG)', '2 parts', '3 levels + articleship', '3 levels'] },
    { label: 'Governing Body', values: ['IRS, USA', 'AICPA / NASBA', 'IMA, USA', 'ICAI', 'ICSI'] },
    { label: 'Eligibility', values: ['10+2, age 18+', 'Bachelor + 120 credits', 'Bachelor', '10+2 (CA Foundation)', '10+2 (CSEET)'] },
    { label: 'Total Fees (INR)', values: ['₹75K – 1.5L', '₹3.5L – 4.5L', '₹1.8L – 2.5L', '₹1L – 3L', '₹40K – 80K'] },
    { label: 'Starting Salary', values: ['₹5–8 LPA', '₹8–12 LPA', '₹6–10 LPA', '₹7–10 LPA', '₹5–8 LPA'] },
    { label: 'Global Recognition', values: ['USA', 'USA + Global', 'USA + Global', 'India + Gulf', 'India'] },
    { label: 'Can Practise Independently', values: ['Yes (IRS License)', 'Yes (State License)', 'Advisory Only', 'Yes (COP)', 'Yes (Company Sec.)'] },
    { label: 'Pass Rate', values: ['~70%', '~50%', '~45%', '~10%', '~15%'] },
  ],
  highlight: 0, // index of EA within values array (0-based)
};
